<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M12 21.8a10 10 0 0 1-7-3A10 10 0 0 1 3.8 6q1.8-2.6 5-3.6.7-.3 1.3.2t.6 1.1a2 2 0 0 1-1 1.5 7 7 0 0 0-3.5 2.5A7 7 0 0 0 5 11.8q0 3 2 5t5 2a7 7 0 0 0 4.7-1.8q.3-.3.9-.3.5 0 .9.3.6.6.6 1.2t-.6 1.2a10 10 0 0 1-6.5 2.4m7-10A7 7 0 0 0 14.2 5q-.4-.1-.7-.6-.3-.3-.3-.9t.6-1.1 1.3-.2A10 10 0 0 1 22 12.7l-.2 1q0 .7-.7 1-.6.5-1.4 0-.4 0-.7-.6-.3-.4-.1-1z"
    />
  </svg>
</template>
